import { Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE } from '../utils/constants';

/** A person's load as "112%" beside their bar - red when overloaded, "-" with no capacity in the range. */
export default function LoadPercent({ row }) {
  return (
    <Typography
      component="span"
      sx={{ width: 48, flexShrink: 0, textAlign: 'right', fontSize: 13, fontWeight: 700, ...FIGURE, color: row.level === 'overloaded' ? LEVEL_TONE.overloaded.text : WD.ink }}
    >
      {row.capacity ? `${Math.round(row.pct)}%` : '-'}
    </Typography>
  );
}
